import React from 'react';
import styles from './AdminCityList.module.scss';
import { Box, Button } from '@mui/material';
import { formatPhoneNumber } from '../AdminUserList/AdminUserList';
import dayjs from 'dayjs';
import AdminTableList from '../../../components/admin/AdminTableList/AdminTableList';
import Player from 'react-player';
// import { clubList } from '../../../redux/actions/app/clubList';
import { exerciseList } from '../../../redux/actions/app/exerciseList';
import { Add } from '@mui/icons-material';
import { useNavigate } from 'react-router';
import { cityList } from '../../../redux/actions/app/cityList';
const AdminCityList = () => {
  const columns = [
    {
      label: 'Город',
      onTransform: (val) => val?.name,
    },
    {
      label: 'Страна',
      onTransform: (val) => val?.citizenship?.name,
    },
  ];
  const navigate = useNavigate();
  return (
    <div>
      <Button
        onClick={() => {
          navigate('/admin/city/create');
        }}
        variant="contained"
        sx={{ display: 'flex', ml: 'auto', marginBottom: '-36.5px' }}
        endIcon={<Add />}>
        Добавить
      </Button>
      <AdminTableList title={'Города'} sliceName={'app'} actionName={'cityList'} fetch={cityList} pathEdit="/admin/city/edit" columns={columns} textEmpty={'Городов нет'} noLock perPage={2000} />
    </div>
  );
};

export default AdminCityList;
